import { Skeleton } from "antd";
import styles from "../../../styles/Components/new-dashboard/DashboardLoaders.module.css";

function SignalsLoader({ view = "card" }) {
  return (
    <div className={`${styles.signalsLoader} ${styles?.[view]}`}>
      {Array.from({ length: 4 })?.map((_, i) => (
        <Skeleton.Node key={i} active />
      ))}
    </div>
  );
}

export default SignalsLoader;
